export const replace_ = (value: string) => value.replaceAll('_', ' ')
export const replaceDIAMOND_ = (value: string) =>
    replace_(value.replace(`DIAMOND_`, ''))
export const formatNumericProperty = (value: number) => value.toFixed(2)
